import { useRef, useEffect } from "react";

/**
 * Hook to track trail changes and prevent race conditions
 * Separated from URL sync to improve clarity and prevent side effects
 */
export const useTrailChangeTracker = (currentTrailId: string | null) => {
  const previousTrailIdRef = useRef(currentTrailId);

  // Track trail changes with stable reference
  useEffect(() => {
    if (
      currentTrailId !== null &&
      previousTrailIdRef.current !== currentTrailId
    ) {
      previousTrailIdRef.current = currentTrailId;
    }
  }, [currentTrailId]);

  // Function to check if trail has changed
  const hasTrailChanged = (): boolean => {
    return (
      previousTrailIdRef.current !== currentTrailId && currentTrailId !== null
    );
  };

  return {
    hasTrailChanged,
    previousTrailId: previousTrailIdRef.current,
  };
};
